import { useEffect } from 'react';

export default function useOutsideClick(ref, onClickOutside, active = true) {
  useEffect(() => {
    if (!active) return;

    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClickOutside();
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [ref, onClickOutside, active]);
}